/* eslint-disable @typescript-eslint/no-explicit-any */
import { useEffect } from "react";

declare global {
  interface Window {
    clarity?: (...args: any[]) => void;
    __clarity_started?: boolean;
  }
}

export function useClarity() {
  useEffect(() => {
    if (typeof window === "undefined") return;

    const clarityId = import.meta.env.VITE_CLARITY;

    if (!clarityId) {
      console.warn("[Clarity] No project ID found in environment variables");
      return;
    }

    if (window.__clarity_started) {
      return;
    }

    try {
      // Insert Clarity script
      (function (c: any, l: Document, a: string, r: string, i: string) {
        c[a] =
          c[a] ||
          function (...args: any[]) {
            (c[a].q = c[a].q || []).push(args);
          };
        const t = l.createElement(r) as HTMLScriptElement;
        t.async = true;
        t.src = "https://www.clarity.ms/tag/" + i;
        const y = l.getElementsByTagName(r)[0] as HTMLElement;
        y?.parentNode?.insertBefore(t, y);
      })(window, document, "clarity", "script", clarityId);

      window.__clarity_started = true;
      console.info(
        "[Clarity] Successfully initialized with ID of type:",
        typeof clarityId,
      );
    } catch (error) {
      console.error("[Clarity] Initialization failed:", error);
    }
  }, []);
}
